export { $editorAttachmentFullscreen, setAttachmentFullscreenEvent } from './editor-attachment-fullscreen';
